export default __webpack_public_path__ + "static/media/coachbetter-ball.c2733cb6.svg";